export default __webpack_public_path__ + "static/media/noexpl_03_DE.6c60a88a.png";